import { render, staticRenderFns } from "./ImgCutter.vue?vue&type=template&id=97443e36&scoped=true"
import script from "./ImgCutter.vue?vue&type=script&lang=js"
export * from "./ImgCutter.vue?vue&type=script&lang=js"
import style0 from "./ImgCutter.vue?vue&type=style&index=0&id=97443e36&prod&lang=scss&scoped=true"
import style1 from "./ImgCutter.vue?vue&type=style&index=1&id=97443e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97443e36",
  null
  
)

export default component.exports